import styled from 'styled-components';
import { Button, Link } from '../../atoms';
import { colors, fontSizes, fontWeights, spacing } from '../../../defaultTheme';
import severityOptions from './helpers';
import query from '../../../const/mediaQueries';
export const AlertContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ severity }) => severityOptions[severity].alertBackgroundColor};
  border-bottom: 2px solid
    ${({ severity }) => severityOptions[severity].iconColor};
  padding: ${spacing.medium}px 96px;
  @media ${query.lessThanMedium} {
    padding: ${spacing.medium}px ${spacing.base}px;
  }
`;
export const AlertTitle = styled.span `
  font-weight: ${fontWeights.bold};
  color: ${({ severity }) => severityOptions[severity].alertTextLabel};
  overflow-wrap: break-word;
`;
export const AlertMessage = styled.span `
  overflow-wrap: break-word;
`;
export const IconContainer = styled.div `
  color: ${({ severity }) => severityOptions[severity].iconColor};
  margin-right: ${spacing.base}px;
  font-size: ${fontSizes.medium}px;
  display: flex;
  height: ${spacing.large}px;
  width: ${spacing.large}px;
  align-items: center;
`;
export const IconSizeContainer = styled.div `
  font-size: ${fontSizes.medium}px;
`;
export const MessageLinkContainer = styled.div `
  display: inline-block;
  width: 90%;
`;
export const ContentContainer = styled.div `
  display: flex;
  max-width: 1200px;
  width: 100%;
`;
export const CloseIcon = styled(Button) `
  padding-left: ${spacing.small}px;
  align-items: flex-start;
  margin: 0 ${spacing.small}px;
  font-size: 20px;
  color: ${colors.black};
`;
export const StyledLink = styled(Link) `
  padding: ${spacing.small}px 0 0 0;
  justify-content: flex-start;
  min-height: fit-content;
  word-break: break-all;
`;
export const CloseIconContainer = styled.div `
  margin-left: auto;
`;
//# sourceMappingURL=subcomponents.js.map